import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Typography } from "@mui/material";

export default function Selector({ label, options, noneValue, formik, name }) {
	return (
		<Box sx={{ width: "100%" }}>
			<FormControl fullWidth>
				<label style={{ margin: "10px 0px" }}>
					{label}
					<span style={{ color: "red", marginLeft: "5px" }}>*</span>
				</label>
				<Select
					value={formik.values?.[name] || ""}
					displayEmpty
					name={name}
					onChange={formik.handleChange}
				>
					{" "}
					<MenuItem disabled value="">
						<em style={{ color: "grey" }}>{noneValue}</em>
					</MenuItem>
					{options.map((option, index) => (
						<MenuItem key={index} value={option?.value}>
							{option.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			{formik.touched[name] && formik.errors[name] && (
				<Typography sx={{ color: "red" }}>
					{formik.errors[name]}
				</Typography>
			)}
		</Box>
	);
}
